module.exports = __webpack_public_path__ + "img/menuIcon4.05964bc0.png";